import { Module } from "plugins/_application";
import Glide from '@glidejs/glide';
import { ArrowControls, ArrowDisabler, ArrowResizer, CanSlide } from '../utils/_glide-plugins';
import { objectFit } from "../utils/_object-fit";
import { debounce } from '../utils/_debounce';

var $ = jQuery;

export default class EmployeeSlider extends Module {

	ready(app) {

        this.WRAPPER = document.getElementById('mtt-employees');
        if (!this.WRAPPER) return;

        this.BREAKPOINT = 1160;
        this.SELECTOR_EL = this.WRAPPER.querySelector('.glide');
        this.TOGGLES = this.WRAPPER.querySelectorAll('.mtt-employees__toggle');
        this.DIST = this.WRAPPER.querySelector('.mtt-employees__dist .glide__slides');
        this.LOADER = this.WRAPPER.querySelector('.mtt-employees__loader');
        this.SWIPE_ICONS = this.WRAPPER.querySelectorAll('.swipe-icon');
        
        this.icons_hidden = false;
        this.slider_init = false;
        this.data = {
            'action': 'filter_employees'
        };

        this.initSlider();
        this.toggleEventListeners();

        // If cat isset
        if(this.findGetParameter('cat')){
            const ID = this.findGetParameter('cat');
            const TOGGLE = this.WRAPPER.querySelector('.mtt-employees__toggle[data-cat="'+ID+'"]');
            if(!TOGGLE) return;
            // set active toggle
            this.setActiveToggle(TOGGLE);

            // // update cat
            this.data.cat = ID;

            // // load posts
            this.loadPosts();

            // // hide icons on click
            this.hideSwipeIcons();
        }

    }

    findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        location.search
            .substr(1)
            .split("&")
            .forEach(function (item) {
              tmp = item.split("=");
              if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
        return result;
    }

    toggleEventListeners() {
        if (!this.TOGGLES) {
            return;
        }

        for (let i = 0; i < this.TOGGLES.length; i++) {    
            const TOGGLE = this.TOGGLES[i];

            TOGGLE.addEventListener('click', () => {

                // set active toggle
                this.setActiveToggle(TOGGLE);

                // update cat
                this.data.cat = this.getCatId(TOGGLE);

                // load posts
                this.loadPosts();

                // hide icons on click
                this.hideSwipeIcons();

            });
        }
    }

    sliderEventListeners() {

        // hide icons on swipe start
        this.SLIDER.on('swipe.start', this.hideSwipeIcons.bind(this));
    }

    setActiveToggle(toggle) {
        for (let i = 0; i < this.TOGGLES.length; i++) {
            this.TOGGLES[i].classList.remove('active');
        }
        toggle.classList.add('active');
    }

    getCatId(el) {
        return el.getAttribute('data-cat');
    }

    loadPosts() {

        this.showLoader();

        jQuery.post(main_theme_objects.ajax_url, this.data, (response) => {
            if (response != 0 && this.DIST) {

                // post markup
                this.DIST.innerHTML = response.markup;

                // run after
                objectFit();

                // destroy and remount
                this.destroySlider();
                this.initSlider();
                
                this.hideLoader();

            }
        });
    }

    initSlider() {
        this.BREAKPOINT >= this.getScreenWidth() ? this.createSlider() : '';
        window.addEventListener('resize', debounce(() => {
            this.BREAKPOINT >= this.getScreenWidth() ? this.createSlider() : this.destroySlider();
        }, 300));
    }

    createSlider() {
        if (this.slider_init) {
            return;
        }

        // init slider
        this.SLIDER = new Glide(this.SELECTOR_EL, {
            type: 'slider',
            startAt: 0,
            perView: 1,
            gap: 56,
            animationDuration: 700,
            keyboard: false,
            bound: true,
            rewind: false,
            dragThreshold: 30,
            swipeThreshold: 50,
            peek: { before: 0, after: 0 },
            breakpoints: {
                1160: {
                    gap: 56,
                    peek: { before: 0, after: 400 }
                },
                1000: {
                    gap: 56,
                    peek: { before: 0, after: 300 }
                },
                900: {
                    gap: 40,
                    peek: { before: 0, after: 230 }
                },
                800: {
                    gap: 56,
                    peek: { before: 0, after: 150 }
                },
                750: {
                    gap: 56,
                    peek: { before: 0, after: 0 }
                },
            }
        });

        // mount slider
        this.SLIDER.mount({ CanSlide });

        // update var
        this.slider_init = true;

        // init slide events
        this.sliderEventListeners();
    }

    destroySlider() {
        if (!this.slider_init) {
            return;
        }

        this.SLIDER.destroy();

        this.slider_init = false;
    }

    showLoader() {
        if (!this.LOADER && !this.DIST) {
            return;
        }

        this.DIST.classList.add('loading');
        this.LOADER.classList.add('loader--show');
    }

    hideLoader() {
        if (!this.LOADER && !this.DIST) {
            return;
        }

        this.DIST.classList.remove('loading');
        this.LOADER.classList.remove('loader--show');
    }

    hideSwipeIcons() {
        if (!this.DIST && !this.SWIPE_ICONS.length && this.icons_hidden) {
            return;
        }

        for (let i = 0; i < this.SWIPE_ICONS.length; i++) {
            this.SWIPE_ICONS[i].classList.add('swipe-icon--hide');
        }

        this.icons_hidden = true;
    }

    getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}